<template>
 <div>
    <b-card-group deck class="speaker_deck">
    <b-card v-for="(speaker,index) in $parent.event.speakers"
        title="" sub-title="" class="speaker_card">
	<img v-if="speaker.pic" :src="speaker.pic" class="speakerimg"/>&nbsp; &nbsp;
	<div class="land_title">{{ speaker.name }}&nbsp;
	<b-link v-if="speaker.bio"
           @click="openbio(speaker.bio)">
           (Bio)
        </b-link></div><br>
	<div v-if="speaker.descr">{{ speaker.descr }}</div>
 	<b>Session:<br>
           {{ session_for_speaker(speaker).title }} <br>
           {{ datestring(session_for_speaker(speaker))}}
        </b>
    </b-card>
    </b-card-group>
 </div>
</template>

<script>

import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";

export default {
  name: "speakers",
  data() {
    return {
      shash: {}
    };
  },
  components: {
  },
  created() {
  },
  methods: {
    datestring: utils.datestring,
    openbio: utils.openbio,
    room_route: function(session) {
	return "/room/"+session.roomname;
    },
    session_for_speaker: function(speaker) {
      let vue = this;
      let s = vue.shash[""+speaker.sessionid];
      if (!s) {
         vue.$parent.event.sessions.forEach(function(s) {
           vue.shash[""+s.id] = s;
         });
         s = vue.shash[""+speaker.sessionid];
      }
      if (s) { return s; }
      return {};
    },
    setup: function() {
      let vue = this;
      if (!vue.$parent.event.id) { return; }
      vue.shash = {};
    },
  },
  computed: {
  },
  watch: {
     '$parent.event.id': function(to, from) {
         this.setup();
     }
  },
  beforeDestroy() {
  },
  mounted() {
    $("body").removeClass("setbackground");
    this.setup();
  },
};
</script>

<style lang="scss" scoped>
.speaker_deck {
  justify-content: center;
  margin-right:0;
  margin-left:0;
}
.speaker_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 10rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
.date_time {
  font-size:1.2rem;
  font-weight:500;
  text-align:left;
  color:black;
  padding-bottom: 1rem;
}
.para {
  white-space: pre-wrap;
}
.speakerimg {
  border-radius: 50%;
  width: 80px;
  height: 80px;
}
.land_title {
  position: relative;
  font-size:1.8rem;
  font-weight:300;
  text-align:left;
  color:black;
} 
</style>
